const standardizeMessage = (msg) => {
  if (!msg) {
    return msg;
  }
  if (!msg.full_name) {
    if (msg.first_name) {
      msg.full_name = `${msg.first_name || ''} ${msg.last_name || ''}`.trim().replace(/\s+/g, ' ');
    } else if (msg.lead) {
      msg.full_name = `${msg.lead.first_name || ''} ${msg.lead.last_name || ''}`.trim().replace(/\s+/g, ' ');
    } else {
      msg.full_name = msg.caller_name || msg.from_name;
    }
  }
  msg.message = msg.message || msg.event_notes || msg.sms_message || msg.email_snippet;
  return msg;
};

export default standardizeMessage;
